export const routes = {
  list: (page: number, limit: number) =>
    `/parent/voucher-notifications?page=${page}&limit=${limit}`,
  unreadCount: () => `/parent/voucher-notifications/unread-count`,
};
